class StorageService {
	private storage: Storage = window.localStorage;

	private prefix: string;

	constructor(prefix: string) {
		this.prefix = prefix;
	}

	private getPrefixedKey(key: string): string {
		return `${this.prefix}${key}`;
	}

	set(key: string, data: unknown): void {
		const prefixedKey = this.getPrefixedKey(key);
		this.storage.setItem(prefixedKey, JSON.stringify(data));
	}

	get<T>(key: string): T | null {
		const data = this.storage.getItem(this.getPrefixedKey(key));
		if (data === null) return null;

		try {
			return JSON.parse(data) as T;
		} catch {
			return data as unknown as T;
		}
	}

	remove(key: string): void {
		this.storage.removeItem(this.getPrefixedKey(key));
	}

	clear(): void {
		const keys = Object.keys(this.storage);
		keys.forEach((key) => {
			if (key.startsWith(this.prefix)) {
				this.storage.removeItem(key);
			}
		});
	}
}

export const orgStorage = new StorageService('org_');
export const userStorage = new StorageService('att_');
export const adminStorage = new StorageService('adm_');

export type AppStorage = typeof orgStorage;
